export default {
  elements: {},
  init() {
    this.elements.parent = $('nav.childpages');
    if (this.elements.parent.length > 0) {
      setReferences.apply(this);
      initListners.apply(this);
    }
  },
}
function setReferences() {
  // set elements to select later
  this.elements.parentitems = this.elements.parent.find('.page_item_has_children');
  // set child elements in data attr of each excerpt to select later
  this.elements.parentitems.each((index, element) => {
    var $el = $(element);
    $el.data('togglebtn', $el.children('.dropdown-toggle'));
    $el.data('children', $el.children('.children'));
  });

}
function initListners() {
  this.elements.parentitems.each((index, element) => {
    var $el = $(element);

    if ($el.hasClass('current_page_item') && $el.hasClass('page_item_has_children')) {
      $el.addClass('open');
    }

    var menuColH = $('.menu-container').height();
    var menuColW = $('.menu-container').width();

    $el.data('togglebtn').click(() => {
      if ($el.hasClass('open') || $el.hasClass('current_page_parent')) {
        $el.removeClass('open active current_page_ancestor current_page_parent');
        $el.addClass('closed');
      } else {
        $el.addClass('open active');
        $el.removeClass('closed');

        var menuColH = $('.menu-container').height();
        // $('.main-content').height(menuColH + 50 + 'px');
        $('.main-content').css('min-height', menuColH + 50 + 'px');
      }
    });

    $el.data('children').on('transitionend', event => {
      // return if not '.children'
      if (event.target !== event.currentTarget) return;
      if ($(event.currentTarget).height() > 0) {
        // if the children are open, add active for scrolling
        $(event.currentTarget).closest('.page_item_has_children').addClass('active');
      } else {
        // if the children are closed, remove all descendent classes
        $el.find('.page_item_has_children').removeClass('open active');
      }
    });
  });
}



// WEBPACK FOOTER //
// ./scripts/components/childmenu.js